import { Modal, Typography, Button } from "@mui/material";

import styles from "./ConfirmPaymentModal.module.scss";
import { WrapperLoading } from "@src/shared/components";

interface Props {
  open: boolean;
  onClose: () => void;
  paymentUrl?: string;
  isLoading?: boolean;
}

export const ConfirmPaymentModal = ({
  open,
  onClose,
  paymentUrl,
  isLoading = false,
}: Props) => {
  return (
    <Modal open={open} onClose={onClose}>
      <WrapperLoading isLoading={isLoading}>
        <div className={styles.modal}>
          <Typography variant="h6">Подтвердите оплату тарифа</Typography>

          <Typography>
            Для оплаты перейдите по
            <a href={paymentUrl}>"ссылке"</a>
          </Typography>
          <Button onClick={onClose}>Отменить оплату</Button>
        </div>
      </WrapperLoading>
    </Modal>
  );
};
